export function PageLoader() {
  return (
    <div className="grid min-h-[60vh] place-items-center bg-mist">
      <div className="w-[min(520px,calc(100%-32px))] rounded-[2rem] border border-white bg-white/80 p-6 shadow-premium">
        <div className="mb-5 h-4 w-40 animate-pulse rounded-full bg-brand-100" />
        <div className="space-y-3">
          <div className="h-8 animate-pulse rounded-xl bg-slate-100" />
          <div className="h-8 w-4/5 animate-pulse rounded-xl bg-slate-100" />
          <div className="h-28 animate-pulse rounded-3xl bg-slate-100" />
        </div>
      </div>
    </div>
  );
}
